export const menu = {
	header: {
		search: "Search menus",
		create: "Create Menu",
		manualMode: "Manual Mode",
	},
	menuList: "Menu for delivery",
	menuCard: {
		message: "24h operation",
		at: "at",
		delivery: "Delivery",
		table: "Order on table",
		businessHour: "Operating Hours",
		type: "Type",
		active: "active",
		inactive: "inactive",
	},
	noMenu: {
		title: "Menu for delivery",
		message: "Looks like you don't have any menu created yet",
		create: "Create Menu",
	},
	warningNotification:
		"Menu created, but there was a problem registering the opening hours:",
};
